module.exports = __webpack_public_path__ + "img/help-tooltip-warning.3189ed0e.svg";